import React from 'react';
import Grid from '@material-ui/core/Grid';
import { DATE_RANGE_FILTERS, TIME_FRAMES } from 'features/command-center/constants';
import { AutocompleteByWeek } from 'UI/components/atoms/AutocompleteByWeek';
import AutocompleteSelect from 'UI/components/molecules/AutocompleteSelect';

/**
 * @typedef {Object} SimplifiedDateRangeProps
 * @property {DatePeriod} dateRange
 * @property {Function} [onOptionsLoaded]
 * @property {Function} onPeriodChange
 * @property {Function} onTimeFrameChange
 * @property {Function} onWeekChange
 * @property {object} timeFrame
 * @property {*} week
 */

/**
 * @param {SimplifiedDateRangeProps} props
 */
export const SimplifiedDateRange = ({
  dateRange,
  onOptionsLoaded,
  onPeriodChange,
  onTimeFrameChange,
  onWeekChange,
  timeFrame,
  week
}) => {
  return (
    <Grid container spacing={2}>
      <Grid item sm={3} xs={6}>
        <AutocompleteSelect
          defaultOptions={TIME_FRAMES}
          disableClearable
          name="TIME_FRAMESelector"
          onSelect={onTimeFrameChange}
          placeholder="Time Range"
          selectedValue={timeFrame}
        />
      </Grid>

      <Grid item sm={3} xs={6}>
        {timeFrame === TIME_FRAMES[0] ? (
          <AutocompleteSelect
            defaultOptions={DATE_RANGE_FILTERS}
            disableClearable
            name="dateRangeFilter"
            onSelect={onPeriodChange}
            placeholder="Date Range"
            selectedValue={dateRange}
          />
        ) : (
          <AutocompleteByWeek
            onOptionsLoaded={onOptionsLoaded}
            onSelectWeek={onWeekChange}
            value={week}
          />
        )}
      </Grid>
    </Grid>
  );
};
